import React from "react";
import { LINE_PREVIEW } from "common-client/utils/objectTypePreviewIcon/iconPaths";
import { LineIconProps } from "common-client/utils/objectTypePreviewIcon/types";

const LineIcon = ({
  lineColor,
  lineOpacity,
  lineWidth,
  size = 12,
}: LineIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox={LINE_PREVIEW.viewBox}
    fill="none"
    style={{ filter: "drop-shadow(0px 1px 1.5px rgba(0, 0, 0, 0.2))" }}
  >
    <line
      x1={LINE_PREVIEW.x1}
      y1={LINE_PREVIEW.y1}
      x2={LINE_PREVIEW.x2}
      y2={LINE_PREVIEW.y2}
      stroke={lineColor}
      strokeOpacity={lineOpacity}
      strokeWidth={Math.max(lineWidth, 2)}
      strokeLinecap="round"
    />
  </svg>
);

export default LineIcon;
